"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Raven = _interopRequireDefault(require("Raven"));

var _events = _interopRequireDefault(require("../../../events.yaml"));

var _default = function _default(isPublic) {
  return {
    events: _events.default,
    properties: {
      namespace: 'marketplace',
      type: 'content',
      isPublic: isPublic,
      inAppOrPublic: isPublic === true ? 'public' : 'in-app'
    },
    onError: function onError(err) {
      _Raven.default.captureMessage('usage-tracker-js event error', {
        extra: {
          message: err.message
        }
      });
    }
  };
};

exports.default = _default;
module.exports = exports.default;